module.exports = __webpack_public_path__ + "img/gao_1.5c877b77.jpg";